module.exports = __webpack_public_path__ + "images/update-icon.svg";